import React from 'react';
import { CommentLayoutProvider } from './CommentLayoutProvider';
import Container from './Container';

const WhatIfClientTemplate = () => {
  return (
    <CommentLayoutProvider>
      <Container />
    </CommentLayoutProvider>
  );
};

export default WhatIfClientTemplate;
